const Settings = {
  API_URL: 'https://6ahxjcz2yd.execute-api.us-east-1.amazonaws.com/dev'
};

export default Settings;
